import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnChanges, inject } from '@angular/core';

import { EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { ShowInEpcotDirective } from '@frontend/sports/common/core/feature/show-in-epcot';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';
import { TrackingSource } from '@frontend/sports/tracking/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxFor } from '@rx-angular/template/for';
import { NgxPopperjsModule, NgxPopperjsPlacements, NgxPopperjsTriggers } from 'ngx-popperjs';

import { EventPickComponent } from '../../option-pick/event-pick.component';

@Component({
    selector: 'ms-option-group',
    templateUrl: 'option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        RxFor,
        EventPickComponent,
        NativePriceFormatterPipe,
        IconCustomComponent,
        FontResizerComponent,
        ShowInEpcotDirective,
        NgxPopperjsModule,
    ],
})
export class OptionGroupComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() optionGroup: EventOptionGroup;
    @Input() isOneWaySpecial: boolean;
    @Input() optionNames?: string[];
    @Input() showDropDown = false;
    @Input() hasImage: boolean;
    @Input() tracking: TrackingSource;
    @Input() disableOdds: boolean;
    @Input() isPriceBoosted: boolean;
    @Input() isFromPortal?: boolean;
    @Input() isLargeLockIcon?: boolean;
    @Input() showTooltipForLockedOdds?: boolean;

    @HostBinding('class') className = 'card-option-group';
    isOptionNamesAvailable = false;
    isThreeWayMarketAvailable = false;
    showCardResultName = false;
    sourceOfPick: SourceOfPick;

    protected readonly NgxPopperjsPlacements = NgxPopperjsPlacements;
    protected readonly NgxPopperjsTriggers = NgxPopperjsTriggers;

    readonly sitecore = inject(Sitecore);

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    trackOption(index: number, option: EventOption): number {
        return option.id;
    }

    getOptionName = (index: number): string => (this.optionNames ? this.optionNames[index] : '');

    isPopperDisabled = (option: EventOption): boolean => (this.optionGroup.online && option.online) || !this.showTooltipForLockedOdds;

    ngOnChanges(): void {
        if (this.optionNames) {
            this.optionNames = this.optionNames.filter((option) => !!option);
            this.isOptionNamesAvailable = !!this.optionNames.length;
            this.isThreeWayMarketAvailable = this.optionNames.length === 3;
            this.showCardResultName = !this.isOneWaySpecial && this.isOptionNamesAvailable && !this.showDropDown;
        }
    }
}
